import usePrivateAxios from "@/common/api/usePrivateAxios"
import { BillingTransactionIdentifier } from "@/common/types/billing/transactionIdentifier.type"
import { ErrorResponse } from "@/common/types/errorResponse"
import { useMutation } from "@tanstack/react-query"

interface UseTransactionIdentifierWithReceiptProps {
  transactionIdentifierId?: string
  onSuccess?: (response: BillingTransactionIdentifier) => void
  onError?: (error: ErrorResponse) => void
}

export const useTransactionIdentifierWithReceipt = ({ transactionIdentifierId, onSuccess, onError }: UseTransactionIdentifierWithReceiptProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationFn: () => privateAxios.get(`/billing/transaction_identifiers/${transactionIdentifierId}/show_with_receipt`),
    onSuccess: (response) => onSuccess?.(response.data.data),
    onError,
  })
}
